import {z} from 'zod';

export const workshopInterestCreateFormSchema = z.object({
  customer: z
    .object({
      id: z.string().nullable(),
    })
    .nullable()
    .optional(),
  sourceCodeId: z.array(z.string()).min(1),
});

export type WorkshopInterestCreateFormSchemaType = z.infer<typeof workshopInterestCreateFormSchema>;
